// extracted by mini-css-extract-plugin
module.exports = {"section_top_rank":"study_top_rank_two_section_top_rank__KMAHT","wrapper":"study_top_rank_two_wrapper__GEwxJ","title_wrapper":"study_top_rank_two_title_wrapper__rXF1z"};